import { createSlice } from "@reduxjs/toolkit";

// Create a slice for categories
const productSlice = createSlice({
  name: "product",
  initialState: {
    productItems: [],
    product: {},
    loading: false,
    error: null,
  },
  reducers: {
    setProductItems: (state, action) => {
      state.productItems = action.payload.data || [];
      state.loading = false;
    },
    setProduct: (state, action) => {
      state.product = action.payload.data || [];
      state.loading = false;
    },
  },
});

// Export the loading and error selectors if needed
export const selectProductLoading = (state) => state.product.loading;
export const selectProductError = (state) => state.product.error;
export const selectProductItems = (state) => state.product.productItems;
export const selectProduct = (state) => state.product.product;

// Export the reducer to include in the store
export const { setProduct, setProductItems } = productSlice.actions;
export default productSlice.reducer;
